import { useState } from "react";
import { testimonials } from "@/mocks/homeData";

export default function TestimonialSection() {
  const [current, setCurrent] = useState(0);

  const prev = () => {
    setCurrent((c) => (c === 0 ? testimonials.length - 1 : c - 1));
  };

  const next = () => {
    setCurrent((c) => (c === testimonials.length - 1 ? 0 : c + 1));
  };

  const t = testimonials[current];

  return (
    <section className="relative w-full py-16 md:py-20 px-6 md:px-10 lg:px-16 bg-background-50 overflow-hidden">
      <div className="absolute left-0 top-1/2 -translate-y-1/2 opacity-[0.05] pointer-events-none">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20minimalist%20fashion%20flat%20lay%20with%20a%20single%20luxury%20watch%20on%20a%20cream%20textured%20surface%2C%20soft%20warm%20lighting%2C%20high%20end%20product%20photography%2C%20subtle%20reflections%2C%20refined%20editorial%20style%2C%20clean%20composition&width=200&height=400&seq=testimonial-deco-left-v2&orientation=portrait"
          alt=""
          className="w-24 md:w-32 h-auto object-cover"
        />
      </div>
      <div className="absolute right-0 top-1/2 -translate-y-1/2 opacity-[0.05] pointer-events-none">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20minimalist%20fashion%20flat%20lay%20with%20a%20single%20designer%20handbag%20detail%20on%20a%20cream%20textured%20surface%2C%20soft%20warm%20lighting%2C%20luxury%20product%20photography%2C%20subtle%20shadows%2C%20refined%20editorial%20style%2C%20clean%20composition&width=200&height=400&seq=testimonial-deco-right-v2&orientation=portrait"
          alt=""
          className="w-24 md:w-32 h-auto object-cover"
        />
      </div>

      <div className="relative z-10 max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-3">
            Cosa Dicono i Nostri Utenti
          </h2>
        </div>

        <div className="bg-background-50 rounded-2xl border border-background-200/70 p-8 md:p-10">
          <div className="flex items-center gap-2 mb-6">
            <span className="px-3 py-1.5 bg-accent-500 text-background-50 rounded-full text-xs font-semibold whitespace-nowrap flex items-center gap-1.5">
              <span className="w-3 h-3 flex items-center justify-center">
                <i className="ri-star-fill text-yellow-300 text-xs"></i>
              </span>
              {t.rating}.0
            </span>
          </div>

          <blockquote className="mb-8">
            <p className="font-heading text-lg md:text-xl italic text-foreground-700 leading-relaxed">
              &ldquo;{t.text}&rdquo;
            </p>
          </blockquote>

          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <img
                src={t.avatar}
                alt={t.name}
                className="w-12 h-12 rounded-full object-cover"
              />
              <div>
                <p className="text-sm font-semibold text-foreground-800">{t.name}</p>
                <p className="text-xs text-foreground-500">{t.role}</p>
              </div>
            </div>

            <div className="flex items-center gap-2">
              <button
                onClick={prev}
                className="w-9 h-9 flex items-center justify-center rounded-lg border border-background-300/60 bg-background-50 text-foreground-600 hover:bg-accent-500 hover:text-background-50 hover:border-accent-500 transition-all duration-200 cursor-pointer"
                aria-label="Precedente"
              >
                <i className="ri-arrow-left-s-line"></i>
              </button>
              <button
                onClick={next}
                className="w-9 h-9 flex items-center justify-center rounded-lg bg-accent-500 text-background-50 hover:bg-accent-600 transition-all duration-200 cursor-pointer"
                aria-label="Successivo"
              >
                <i className="ri-arrow-right-s-line"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}